import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForUserVisible } from '@atlassian/react-async';

type LegacyPageEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const legacyPageEntrypoint: EntryPoint<LegacyPageEntrypointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForUserVisible<LegacyPageEntrypointComponent>(
			/* webpackChunkName: "async-legacy-page-entrypoint" */ './index.tsx',
		),
		getPreloadProps: () => ({}),
	},
);
